import React, { useState } from "react";

/**
 * Animates expand/collapse using the CSS grid `0fr -> 1fr` row technique, which
 * transitions smoothly regardless of the content's natural height.
 *
 * Children mount on first open and stay mounted afterwards so the collapse can
 * animate. `visibility: hidden` (inline, so tests can assert on it) removes the
 * collapsed content from the accessibility tree and tab order; the visibility
 * transition keeps content visible until the collapse animation finishes.
 */
const CollapsibleContent = ({ isOpen, id, children }) => {
    const [hasBeenOpen, setHasBeenOpen] = useState(isOpen);
    if (isOpen && !hasBeenOpen) setHasBeenOpen(true);

    return (
        <div
            id={id}
            className={`grid transition-[grid-template-rows,visibility,opacity] duration-300 ease-in-out motion-reduce:transition-none ${isOpen ? "opacity-100" : "opacity-0"}`}
            style={{
                gridTemplateRows: isOpen ? "1fr" : "0fr",
                visibility: isOpen ? "visible" : "hidden",
            }}
        >
            <div className="min-h-0 overflow-hidden">
                {hasBeenOpen ? children : null}
            </div>
        </div>
    );
};

export default CollapsibleContent;
